import React from 'react'
import Index from '../_components/Profile/Index'

const Profile = () => {
    
  return (
    <Index />
  )
}

export default Profile